const USERS = 'users'
const LOGS = 'logs'
const RENTING_REQUESTS = 'rentingRequests'
const NOTIFICATIONS = 'notifications'
const PAYMENTS = 'payments'
const MEDIA_OBJECTS = 'mediaObjects'
const CATEGORIES = 'categories'
const ADDRESSES = 'addresses'
const CANCELLATION_TERMS = 'cancellationTerms'
const REVIEWS = 'reviews'
const COMPLAINTS = 'complaints'
const FIELDS = 'fields'
const TAGS = 'tags'
const PAYMENT_METHODS = 'paymentMethods'
const PRODUCTS = 'products'
const ORDERS = 'orders'
const CUSTOMERS = 'users'
const TICKETS = 'tickets'
const BRANDS = 'brands'
const CARTS = 'carts'
const CHATS = 'chats'
const CHAT_USERS = 'chat_users'
const USER_STATUSES = 'user_statuses'
const MEMBERS = 'members'
const STRIPE_CONNECTED_ACCOUNTS = 'stripeConnectedAccounts'
const STRIPE_REFUNDS = 'stripeRefunds'

export const COLLECTIONS = {
  USERS,
  LOGS,
  RENTING_REQUESTS,
  NOTIFICATIONS,
  PAYMENTS,
  MEDIA_OBJECTS,
  CATEGORIES,
  ADDRESSES,
  CANCELLATION_TERMS,
  REVIEWS,
  COMPLAINTS,
  FIELDS,
  TAGS,
  PAYMENT_METHODS,
  PRODUCTS,
  ORDERS,
  CUSTOMERS,
  TICKETS,
  BRANDS,
  CARTS,
  CHATS,
  CHAT_USERS,
  USER_STATUSES,
  MEMBERS,
  STRIPE_CONNECTED_ACCOUNTS,
  STRIPE_REFUNDS
}

export default COLLECTIONS
